export default {
  initialize: state => ({
    type: 'FILTERS_INITIALIZE',
    state,
  }),
  setFilters: filters => ({
    type: 'FILTERS_SET_FILTERS',
    filters,
  }),
  setActiveFilters: activeFilters => ({
    type: 'FILTERS_SET_ACTIVE_FILTERS',
    activeFilters,
  }),
  setFixedFilters: fixedFilters => ({
    type: 'FILTERS_SET_FIXED_FILTERS',
    fixedFilters,
  }),
  setFilterSelection: filterSelection => ({
    type: 'FILTERS_SET_FILTER_SELECTION',
    filterSelection,
  }),
  setLoadFilterOptions: loadFilterOptions => ({
    type: 'FILTERS_SET_LOAD_FILTER_OPTIONS',
    loadFilterOptions,
  }),
};
